import { useCallback, useEffect, useMemo, useState } from 'react'
import { getRandomDomain } from '@/utils/urlUtils/domainPool'
import { ProviderPropsType } from '@/typings/types'

const keyList = ['dynamicDomain']

export default function useProvider(props: {
  providerKeys: string[]
}): {
  providerProps: ProviderPropsType
} {
  const { providerKeys } = props
  const [dynamicDomain, setDynamicDomain] = useState({
    domain: typeof window !== 'undefined' ? window.location.host : '',
    newDomainUrl: typeof window !== 'undefined' ? window.location.href : '',
  })

  const getDynamicDomain = useCallback(() => {
    getRandomDomain().then((res) => {
      setDynamicDomain(res)
    })
  }, [])

  useEffect(() => {
    providerKeys.forEach((element) => {
      // just transfer
      if (keyList.includes(element)) {
        getDynamicDomain()
      }
    })
  }, [providerKeys, getDynamicDomain])

  // just transfer
  const providerProps = useMemo(() => {
    return { dynamicDomain }
  }, [dynamicDomain])
  return { providerProps }
}
